import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, IconButton, Tooltip} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
// import Settings from '@material-ui/icons/Settings';
import DatasheetView from './DatasheetView';
import moment from 'moment';
import XLSX from 'xlsx';
// import ExcelLogo from '../assets/icons8-export-excel-24.png';
import ExcelLogo from '../assets/ExcelLogo';
import FilterBox from './FilterBox';

export default class AssessmentHistory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: false,
            error_message: '',
            querying: true,
            pending_assessments_array: [],
            create_assessment: false,
            assessment_type: '',
            assessment: {},
            filtered_assessments_array: [],
            filter_applied: false,
            filter_obj: {},
        }

        this.datasheetFieldSpecs = [
            { field: 'store_code', headerName: 'Branch', width: 110, align:'center',headerAlign:'center'},
            { field: 'region', headerName: 'Region', width: 110, align:'center',headerAlign:'center'},
            { field: 'assessee_id', headerName: 'Empl.#', width: 110, align:'center',headerAlign:'center'},
            { field: 'assessee', headerName: 'Assessee', width: 160},
            { field: 'cycle_code', headerName: 'Cycle Code', width: 160},
            { field: 'assessment_template_id', headerName: 'Type', width: 90, align:'center',headerAlign:'center'},
            { field: 'assessment_type_id', headerName: 'By', align: 'center', headerAlign:'center', width: 80, sortable:false},
            { field: 'created', headerName: 'Created', headerAlign:'center', align:'center', width: 120},
            { field: 'key_datapoint_score', headerName: 'Score', headerAlign:'right',align:'right', width: 100, sortable:false},
            { field: 'key_datapoint_out_of', headerName: 'Out Of', width: 100, headerAlign:'right',align:'right', sortable:false},
            { field: 'created', headerName: 'Created', width: 120},
            { field: 'approved', headerName: 'Approved?', align: 'center',width: 100, sortable: false},
            { field: 'key_comment', headerName: 'Comment', width: 200, sortable:false},
        ]
    }

    componentDidMount = () => {
        
        Gserv.sendCommand('query_my_assessment_history',this.props.gwt)
        .then(reply=>{
            // console.log('query_my_assessment_history reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_my_assessment_history) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_my_assessment_history) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                
                //clean formats for display
                if (reply.Records){
                let record_array = reply.Records;
                    let created_date = null;
                    for (var i=0;i<record_array.length;i++){
                        created_date = new moment(record_array[i].created).format("YYYY-MM-DD");
                        record_array[i].created = created_date;
                        record_array[i].approved = record_array[i].approved ? "YES" : "";
                    }
                }

                if (this.state.filter_applied){
                    this.setState({querying:false, pending_assessments_array:reply.Records?reply.Records : []});
                    if (!reply.Records) {this.setState({filtered_assessments_array:[]})}
                    this.applyFilter(this.state.filter_obj);
                } else {
                    this.setState({querying:false, pending_assessments_array:reply.Records?reply.Records : [], filtered_assessments_array:reply.Records?reply.Records : []});
                }

            }
        });
    };

    resetMe = () => {
        this.setState({error: false,error_message: '',querying: true, pending_assessments_array: []});
        this.componentDidMount();
    }

    deleteAss = (record) => {
        // console.log('record :>> ', record);


        if (record.row.approved==="YES"){

            this.setState({error:true,error_message:'Unable to delete assessments which have already been approved.'});

        } else {

            this.setState({querying:true});
            Gserv.sendCommand('delete_assessment',this.props.gwt,{
                assessment_key: record.id
            })
            .then(reply => {
                // console.log('delete reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (delete_assessment) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.Result!=="Success"){
                    console.log('error on return from Gserv (delete_assessment) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    this.setState({error:false,error_message:'',pending_assessments_array:[]});
                    this.componentDidMount();
                }
            });

        }

    }

    handleFilterChange = (filterObj) => {
        // console.log('filterObj :>> ', filterObj);
        if (filterObj.type==='clear'){
            this.setState({filtered_assessments_array : this.state.pending_assessments_array, filter_obj: {}, filter_applied:false})
        } else {
            this.setState({filter_obj:filterObj});
            this.applyFilter(filterObj);
        }
    }

    applyFilter = (filterObj) => {
        if (this.state.pending_assessments_array.length > 0){
            let temp_array = [];
            switch (filterObj.type) {
                case 'name':
                    for (const record of this.state.pending_assessments_array){
                        if (record.assessee.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;

                case 'number':
                    for (const record of this.state.pending_assessments_array){
                        if (record.assessee_id.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;
 
                case 'rom':
                    for (const record of this.state.pending_assessments_array){
                        if (record.reports_to_rom.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;
            
                default:
                    break;
            }
            this.setState({filtered_assessments_array: temp_array, filter_applied:true});
        }
    }

    exportMe = () => {
        // console.log('called exportMe...');
        if (this.state.filtered_assessments_array.length>0){
            const dateStr = new moment().format("YYYY-MM-DD");
            var ws = XLSX.utils.json_to_sheet(this.state.filtered_assessments_array);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'My Assessments ' + dateStr);
            //Write to browser
            XLSX.writeFile(wb,'TMS Export - My Assessments (History) as at ' + dateStr + '.xlsx');
        }
    }

    render() {
        return (
            <Grid
                container
                direction='column'
                justifyContent='flex-start'
                alignContent='flex-start'
                // style={{backgroundColor:'yellow'}}
            >
                {!this.state.create_assessment&&
                <Grid item>
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        width:1230
                    }}
                >

                    <Grid
                        container
                        // style={{backgroundColor:'yellow'}}
                        justifyContent='center'
                        alignContent='center'
                    >

                        <Grid item xs={4}>
                            <Tooltip title="Export to Excel">
                            <span>
                            <IconButton 
                                aria-label='Export to Excel'
                                onClick={this.exportMe}
                                disabled={this.state.filtered_assessments_array.length===0}
                            >
                                <ExcelLogo />
                            </IconButton>
                            </span>
                            </Tooltip>
                        </Grid>

                        <Grid item xs={4}>
                            <Typography
                                style={{padding:10}}
                            >
                                Assessment History
                            </Typography>
                        </Grid>

                        <Grid item xs={4}>
                            <Grid 
                                container
                                alignItems='center'
                                justifyContent='space-evenly'
                                // style={{backgroundColor:'yellow'}}
                            >
                                <FilterBox
                                    setParentFilter={this.handleFilterChange}
                                    data_populated={this.state.pending_assessments_array.length>0? true : false}
                                    filter_applied={this.state.filter_applied}
                                    filter_obj={this.state.filter_obj}
                                    show_hod_filter={false}
                                    // show_branch_filter={true}
                                    // show_cycle_filter={true}
                                />
                            </Grid>
                        </Grid>

                    </Grid>

                    {/* Datagrid goes here */}
                    <DatasheetView 
                        dataset={this.state.filtered_assessments_array}
                        fieldspecs={this.datasheetFieldSpecs}
                        delete={true}
                        edit={false}
                        handleDelete={this.deleteAss}
                        handleEdit={null}
                        loading={this.state.querying}
                        deleteHeaderName={'Delete'}
                        pagesize={10}
                        height={500}
                    />

                </Paper>
                </Grid>}

                <Grid item>
                    <Typography color='secondary' style={{Width:1230,maxWidth:1230, textAlign:'center'}}>{this.state.error_message}</Typography>
                    {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
                </Grid>

            </Grid>
        );
    }
    
}